import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad gäller vid ett tillsynsbesök?";
const SHORT_ANSWER = "Tillsynspersonal har rätt till tillträde under öppettider och kan begära att se egenkontrollprogram, bokföring, ID-kontroll och personalrutiner.";

export const Route = createFileRoute("/fraga/vad-galler-vid-tillsynsbesok")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad gäller vid ett tillsynsbesök" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Polis, Skatteverket och miljökontoret kan vara med vid s.k. samordnad tillsyn. Avvisning av tillsynspersonal är en allvarlig överträdelse."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Tillsyn och sanktioner" }}
      related={[{"to": "/fraga/vad-hander-om-jag-far-en-anmarkning", "label": "Vad händer om jag får en anmärkning vid tillsyn?"}, {"to": "/fraga/hur-overklagar-jag-ett-beslut", "label": "Hur överklagar jag ett beslut om serveringstillstånd?"}, {"to": "/fraga/vad-ar-ordningsvakter-och-nar-kravs-de", "label": "När krävs ordningsvakter på en restaurang?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad gäller vid ett tillsynsbesök?" },
      { name: "description", content: "Tillsynspersonal har rätt till tillträde under öppettider och kan begära att se egenkontrollprogram, bokföring, ID-kontroll och personalrutiner." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-galler-vid-tillsynsbesok" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-galler-vid-tillsynsbesok" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-galler-vid-tillsynsbesok",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad gäller vid ett tillsynsbesök", url: "https://alkoholprovet.se/fraga/vad-galler-vid-tillsynsbesok" },
      ]),
    ],
  }),
});
